import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "@/components/ui";
import { useAuth } from "@/features/auth/AuthContext";

/**
 * Blocks a route until the stored token has been validated.
 *
 * Waiting on `ready` matters: without it, a signed-in operator reloading the
 * page gets bounced to /login for a frame before /me resolves.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) return <BootScreen />;
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
}

export function BootScreen() {
  return (
    <div className="grid min-h-full place-items-center">
      <Spinner size={28} className="text-accent" />
    </div>
  );
}
